// onyx.js: v7 HAUTE COSMOS world. GRAVITY: a polished onyx black hole bending a pearl-white atelier, circled by a lensed pave ring.
// STUB: re-exports the v5 blackhole world so the site keeps working until the onyx agent swaps in './onyx/world.js'.
// Owner: the onyx agent (see web/src/worlds/V7.md).
export { create } from './blackhole.js';
